import React, { useContext } from 'react'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import { toast } from 'pobble-components/dist/toast'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import MyLessonsContext from '../my-lessons.context'
import ShareIcon from '../../../../prompt/share-icon'
import { apiClient } from 'pobble-components/dist/api'

const styles = ({ COLORS }) => ({
  print: {
    color: COLORS.TEXT.MID_GREY.NORMAL
  }
})

const ContextMenu = ({
  classes,
  onArchive,
  copy,
  onShare,
  id,
  setToPublic,
  setToPrivate,
  deleteItem,
  isPublic,
  fetchPresentations,
  delivered,
  openPublicLinkModal,
  token,
  presentation
}) => {
  const { refreshPage, setShareModalState } = useContext(MyLessonsContext)

  return (
    <>
      <DropMenu
        button={({ ref, togglePopover }) => (
          <MoreButton
            className="metrics__my_lessson_context_menu"
            forwardedRef={ref}
            onClick={togglePopover}
          />
        )}>
        {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
          <Menu>
            <MenuItem
              className="metrics__my_lesson_context_action"
              onClick={() => {
                closePopover()
                apiClient
                  .get(`/v3/presentations/${id}`, {
                    params: {
                      include:
                        'presentation.details,presentation.slides,presentation.slide.details,presentation.names'
                    }
                  })
                  .then(res => {
                    setShareModalState({
                      opened: true,
                      presentation: res.data.presentation
                    })
                  })
              }}>
              <IconHolder>
                <ShareIcon />
              </IconHolder>
              Share
            </MenuItem>
            {isPublic && (
              <>
                <Separator />
                <MenuItem
                  className="metrics__my_lesson_context_action"
                  onClick={() => {
                    setToPrivate(id).then(refreshPage)
                    closePopover()
                  }}>
                  <IconHolder>
                    <FontAwesomeIcon icon={faLock} />
                  </IconHolder>
                  Set to private
                </MenuItem>
              </>
            )}
            <Separator />
            <MenuItem
              className="metrics__my_lesson_context_action"
              onClick={() => {
                closePopover()
                copy &&
                  copy(id).then(() => {
                    fetchPresentations({
                      scope: 'all',
                      page: 0,
                      limit: 10
                    }).then(() => toast.success('Lesson has been copied'))
                  })
              }}>
              <IconHolder>
                <FontAwesomeIcon icon={faCopy} />
              </IconHolder>
              Duplicate
            </MenuItem>
            <Separator />
            <MenuItem
              className="metrics__my_lesson_context_action"
              onClick={() => {
                openConfirmationDialog({
                  theme: 'danger',
                  bodyText: `You are removing this lesson from your lesson list. This cannot be undone.${
                    delivered
                      ? `\n\nNote that the work associated with this lesson remains accessible, e.g. via the pupil's profile.`
                      : ''
                  }`,
                  action: () => deleteItem(id).then(refreshPage),
                  confirmText: 'Delete',
                  cancelText: 'Cancel'
                })
                closePopover()
              }}>
              <IconHolder>
                <FontAwesomeIcon icon={faTrashAlt} />
              </IconHolder>
              Delete
            </MenuItem>
          </Menu>
        )}
      </DropMenu>
    </>
  )
}

export default injectSheet(styles)(ContextMenu)
